<template>
	<layout-admin>
		<router-view :key="viewKey"></router-view>
	</layout-admin>
</template>

<script>
import { mapGetters } from 'vuex';

// Al cambiar de empresa en el selector se vuelve a montar la pantalla actual,
// así toma la nueva empresa sin recargar la página.
function currentSubsidiary(newSubsidiary, oldSubsidiary) {
	const oldId = oldSubsidiary && oldSubsidiary.id;
	const newId = newSubsidiary && newSubsidiary.id;
	if (oldId && newId && Number(oldId) !== Number(newId)) {
		this.viewKey += 1;
	}
}

function data() {
	return {
		viewKey: 0,
	};
}

export default {
	name: 'page-home',
	computed: {
		...mapGetters('subsidiary', ['currentSubsidiary']),
	},
	data,
	watch: {
		currentSubsidiary,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/page-home.vue